import PropTypes from 'prop-types';
import React, { Component } from 'react';
import TwitterIcon from 'dibs-vg/dist/react/twitter';
import FacebookIcon from 'dibs-vg/dist/react/facebook';
import PinterestIcon from 'dibs-vg/dist/react/pinterest';
import InstagramIcon from 'dibs-vg/dist/react/instagram';
import { trackSocial } from 'dibs-tracking';

import style from './SocialLinkRow-style.scss';

const iconMap = {
    twitter: TwitterIcon,
    facebook: FacebookIcon,
    pinterest: PinterestIcon,
    instagram: InstagramIcon,
};

class SocialLinkRowItem extends Component {
    constructor(props) {
        super(props);

        this.trackClick = this.trackClick.bind(this);
    }

    trackClick() {
        const { trackingLabel, href } = this.props;
        const eventName = 'fan page';

        trackSocial({
            name: trackingLabel,
            event: eventName,
            opt_target: href,
            opt_pagePath: href,
        });
    }

    render() {
        const { name, href, dataTn } = this.props;

        if (!iconMap[name]) {
            return null;
        }

        const SocialIcon = iconMap[name];

        return (
            <div className={style.item}>
                <a
                    className={`${style.link} ${style[name]}`}
                    title={name}
                    href={href}
                    onClick={this.trackClick}
                    data-tn={dataTn}
                >
                    <SocialIcon type={name} />
                </a>
            </div>
        );
    }
}

SocialLinkRowItem.propTypes = {
    name: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    dataTn: PropTypes.string,
    trackingLabel: PropTypes.string,
};

export default SocialLinkRowItem;
